import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const MenuManagementService = {
  async getAll() {
    return await ApiService.get("api/MenuManagement");
  },

  async getFeatureCodes() {
    return await ApiService.get("api/MenuManagement/feature-codes");
  },

  async getById(id) {
    return await ApiService.get(`api/MenuManagement/${id}`);
  },

  async create(data) {
    ApiService.setHeaders();
    return await ApiService.post("api/MenuManagement", data);
  },

  async update(id, data) {
    ApiService.setHeaders();
    return await ApiService.customRequest({
      method: "put",
      url: `api/MenuManagement/${id}`,
      data,
    });
  },

  async remove(id) {
    ApiService.setHeaders();
    return await ApiService.customRequest({
      method: "delete",
      url: `api/MenuManagement/${id}`,
    });
  },

  async reorder(items) {
    ApiService.setHeaders();
    return await ApiService.customRequest({
      method: "put",
      url: "api/MenuManagement/reorder",
      data: items,
    });
  },
};

export default MenuManagementService;
export { MenuManagementService };
